import settings from '@/config/settings';

import type {TId} from '@/assets/core/assets/api/types';
import type {
  ILayer,
  ILayerCreate,
  ILayerFilters,
  ILayerUpdate,
} from '@/api/types/layer';
import type {IFeature} from '@/api/types/layer/feature';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';
import useRequestPaginationHook from '@/assets/core/assets/hooks/requestPaginationHook';

import {loadAPIImage} from '@/assets/core/assets/api/doRequestImage';

const url = new URL(settings.SERVICES.BACK.getUrl() + '/layers');

const useLayerFeatureAPIHook = () => {
  const getOneToLayer = async (layerId: TId): Promise<IFeature | undefined> => {
    const items = await useRequestPaginationHook<IFeature>(
      `${url}/${layerId}/features`,
      undefined,
      {size: 1},
    ).loadFirstPage();

    return items.length ? items[0] : undefined;
  };

  return {
    getOneToLayer,
  };
};

const useLayerTileAPIHook = () => {
  const getOne = async (id: TId, query: string): Promise<Blob> => {
    const currentUrl = `${url}/${id}/tiles?${query}`;
    return await loadAPIImage(currentUrl);
  };

  return {
    getOne,
  };
};

const useLayerAPIHook = () => {
  return {
    ...useAPIHook<ILayer, ILayer, ILayerCreate, ILayerUpdate, ILayerFilters>(
      url,
    ),

    tile: useLayerTileAPIHook(),
    feature: useLayerFeatureAPIHook(),
  };
};

export const layerAPI = useLayerAPIHook();
